<template>
  <div class="container">
    <div class="page">
      <div class="login">
        <div>
          <span>用户名:</span>
          <input v-model="systemName">
        </div>
        <div>
          <span>密码:</span>
          <input type="password" v-model="systemPassword">
        </div>
        <div>
          <button @click="login">登录</button>
          <button>注册</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      systemName:"admin",
      systemPassword:""
    }
  },
  methods: {
    login() {
      var systemName = this.systemName
      var systemPassword = this.systemPassword
      var url = "systemUser/login";
      var obj = {systemName,systemPassword};
      console.log(obj)
      this.axios.post(url,this.qs.stringify(obj)).then(res=>{
        if(res.data.data.token){
          sessionStorage.setItem('systemId',res.data.data.systemId);
          sessionStorage.setItem('systemName',res.data.data.systemName);
          sessionStorage.setItem('token',res.data.data.token);
          this.$router.push('/MsgList')
        } else {
          alert("用户名或密码错误")
        }
      })
    }
  }
}
</script>

<style scoped>
.login {
  width:564px;
  height:352px;
  background:rgba(47,84,235,1);
  border-radius:16px;
  position: absolute;;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}
.login>div {
  display: flex;
  margin-left: 67px;
}
.login>div:first-child {
  margin-top: 63px;
  margin-bottom: 58px;
}
.login>div span {
  width: 72px;
  text-align: left;
  margin-right: 22px;
}
.login>div input {
  width:282px;
  height:42px;
  border-radius:22px;
  border:1px solid rgba(255,255,255,1);
  background:rgba(47,84,235,1);
  padding: 0 18px;
  caret-color:#fff;
  color: #fff;
}
.login>div:nth-child(2) {
  margin-bottom: 61px;
}
.login>div:nth-child(3) {
  margin-left: 161px;
}
.login>div:nth-child(3)>button {
  width: 140px;
  height: 42px;
  border-radius:36px;
  cursor: pointer;
}
.login>div:nth-child(3)>button:first-child {
  margin-right: 40px;
  background-color: #fff;
  color: #2F54EB;
}
.login>div:nth-child(3)>button:nth-child(2) {
  background-color: #2F54EB;
  color: #fff;
  border:1px solid rgba(255,255,255,1);
}
</style>